import Vue from 'vue'
import Vuex from 'vuex'

import menus from './modules/menus.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
  },
  mutations: {
    //存储token到Vuex中
    SET_TOKEN: (state, tokenValue) => {
      //存储到LocalStorage中
      console.log(tokenValue);
      
      sessionStorage.setItem('TOKEN', JSON.stringify(tokenValue))
      state.token = tokenValue
      
    },
  },
  modules: {
    //大型项目使用，state中数据很多，可以分类存储到不同的modules
    menus,
  },
})
